import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { ColumnCell, ColumnGrid } from '../../common/css_global/mobile/utils.css';
import { MainBodyWrapper, PageWrapper } from './App.css';
import EuCookieBanner from '../../components_common/EuCookieBanner/EuCookieBanner';
import policyActions from '../../common/actions/policyActions';
import UnsupportedBrowser from '../../components_common/UnsupportedBrowser/UnsupportedBrowser';
import Banner from '../../components_common/Banner';
import checkUnsupportedBrowser from '../../helpers/checkUnsupportedBrowser';
import { requiresCookieBanner } from '../../helpers/helpers';

const mapStateToProps = ({
  api: {
    baseUrl,
    basePathWeb,
    countryIso,
    euCookiePolicyAccepted,
    isEu,
    freeShipping,
    metadescription,
    page,
    product,
    title,
  },
  overflowScroll,
}) => ({
  baseUrl,
  basePathWeb,
  countryIso,
  freeShipping,
  metadescription,
  overflowScroll,
  page,
  product,
  title,
  euCookiePolicyAccepted,
  isEu,
});

const mapDispatchToProps = dispatch => ({
  acceptCookies: () => dispatch(policyActions()),
});

class AppComponent extends Component {
  render() {
    const {
      acceptCookies,
      countryIso,
      euCookiePolicyAccepted,
      freeShipping,
      isEu,
      overflowScroll,
      page,
      children,
      currPage,
    } = this.props;

    // Initialize Google Analytics through react-ga
    const { browserIsNotSupported, browserName } = checkUnsupportedBrowser();
    const overflowy = page === 'Home';

    return (
      <PageWrapper>
        <Banner />
        <Header currPage={currPage} />
        <MainBodyWrapper id="main" overflowy={overflowy} overflowScroll={overflowScroll}>
          <ColumnGrid id="grid">
            <ColumnCell style={{ minHeight: '81vh' }}>
              {browserIsNotSupported ? <UnsupportedBrowser browserName={browserName} /> : <>{children}</>}
            </ColumnCell>
            <ColumnCell id="footer">
              <Footer />
            </ColumnCell>
          </ColumnGrid>
          {requiresCookieBanner(isEu, euCookiePolicyAccepted) && <EuCookieBanner handleClick={acceptCookies} />}
        </MainBodyWrapper>
      </PageWrapper>
    );
  }
}

AppComponent.propTypes = {
  acceptCookies: PropTypes.func.isRequired,
  euCookiePolicyAccepted: PropTypes.bool,
  isEu: PropTypes.bool,
  overflowScroll: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
};

const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);
export { App as default, AppComponent };
